import type React from "react";
import { CustomCheckbox } from "~/components/ui/check_Box";
import styles from "../../index.module.scss";
import type { FieldComponentProps } from "../../types";

const NumberOptions: React.FC<FieldComponentProps> = ({
  options,
  onChange,
  isReadOnly = false,
}) => {
  const handleTextChange = (key: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(key, e.target.value);
  };

  const handleCheckboxChange = (key: string) => (checked: boolean) => {
    onChange(key, checked);
  };

  const handleRadioChange = (key: string, value: string) => () => {
    onChange(key, value);
  };

  return (
    <div className={styles["optionSection"]}>
      {/* 数値の範囲 */}
      <div className={styles["subSection"]}>
        <h4>数値の範囲</h4>
        <div className={styles["form-group"]}>
          <label>最小値</label>
          <input
            type="text"
            value={options.minValue || ""}
            onChange={handleTextChange("minValue")}
            disabled={isReadOnly}
            placeholder="未設定"
            className={styles["inputField"]}
          />
        </div>
        <div className={styles["form-group"]}>
          <label>最大値</label>
          <input
            type="text"
            value={options.maxValue || ""}
            onChange={handleTextChange("maxValue")}
            disabled={isReadOnly}
            placeholder="未設定"
            className={styles["inputField"]}
          />
        </div>
      </div>

      {/* 単位設定 */}
      <div className={styles["subSection"]}>
        <h4>単位設定</h4>
        <div className={styles["form-group"]}>
          <label>単位</label>
          <input
            type="text"
            value={options.unit || ""}
            onChange={handleTextChange("unit")}
            disabled={isReadOnly}
            placeholder="例: 円、個、kg"
            className={styles["inputField"]}
          />
        </div>

        <div className={styles["form-group"]}>
          <label>単位の位置:</label>
          <div className={styles["radioGroup"]}>
            <label className={styles["radioLabel"]}>
              <input
                type="radio"
                name="unitPosition"
                checked={options.unitPosition === "BEFORE"}
                onChange={handleRadioChange("unitPosition", "BEFORE")}
                disabled={isReadOnly}
                className={styles["radioInput"]}
              />
              前
            </label>
            <label className={styles["radioLabel"]}>
              <input
                type="radio"
                name="unitPosition"
                checked={options.unitPosition === "AFTER"}
                onChange={handleRadioChange("unitPosition", "AFTER")}
                disabled={isReadOnly}
                className={styles["radioInput"]}
              />
              後
            </label>
          </div>
        </div>
      </div>

      {/* 表示形式 */}
      <div className={styles["subSection"]}>
        <h4>表示形式</h4>
        <div className={styles["checkboxOption"]}>
          <CustomCheckbox
            label="桁区切りを表示する"
            checked={options.digit === true}
            onChange={handleCheckboxChange("digit")}
            disabled={isReadOnly}
          />
        </div>
        <div className={styles["form-group"]}>
          <label>小数点以下の表示桁数</label>
          <input
            type="text"
            value={options.displayScale || ""}
            onChange={handleTextChange("displayScale")}
            disabled={isReadOnly}
            placeholder="例: 2"
            className={styles["smallInputField"]}
          />
        </div>
      </div>

      {/* その他の設定 */}
      <div className={styles["subSection"]}>
        <h4>その他の設定</h4>
        <div className={styles["checkboxOption"]}>
          <CustomCheckbox
            label="値の重複を禁止する"
            checked={options.unique === true}
            onChange={handleCheckboxChange("unique")}
            disabled={isReadOnly}
          />
        </div>
        <div className={styles["checkboxOption"]}>
          <CustomCheckbox
            label="必須項目にする"
            checked={options.required === true}
            onChange={handleCheckboxChange("required")}
            disabled={isReadOnly}
          />
        </div>
        <div className={styles["checkboxOption"]}>
          <CustomCheckbox
            label="フィールド名を表示しない"
            checked={options.noLabel === true}
            onChange={handleCheckboxChange("noLabel")}
            disabled={isReadOnly}
          />
        </div>
      </div>
    </div>
  );
};

export default NumberOptions;
